import { useState, useEffect } from 'react'

const MOBILE_BREAKPOINT = 768

export function useIsMobile() {
  const [isMobile, setIsMobile] = useState<boolean | undefined>(undefined)

  useEffect(() => {
    const mql = window.matchMedia(
      `(max-width: ${String(MOBILE_BREAKPOINT - 1)}px)`
    )
    const onChange = () => {
      const next = window.innerWidth < MOBILE_BREAKPOINT
      // `resize` fires on every frame of a drag, but the boolean only flips at
      // the 768px boundary. Return the SAME state reference when it hasn't
      // changed so React bails out of the re-render - otherwise every consumer
      // (and its subtree) re-renders on each resize event.
      setIsMobile((prev) => (prev === next ? prev : next))
    }
    // Also re-sync on window resize — iPadOS can drop the matchMedia
    // change-back event when the window resizes during app switching.
    mql.addEventListener('change', onChange)
    window.addEventListener('resize', onChange)
    onChange()
    return () => {
      mql.removeEventListener('change', onChange)
      window.removeEventListener('resize', onChange)
    }
  }, [])

  return Boolean(isMobile)
}
